<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="hideModal()">
                    <span>×</span><span class="sr-only">Close</span>
                </button>
                <h4 class="modal-title">View Pass On Log</h4>
            </div>
            <div class="modal-body">
                <!-- ___ Building ___ -->
                <div class="row m-b-sm">
                    <div class="col-md-4">
                        <label>Building</label>
                    </div>
                    <div class="col-md-8 fourteenPixelText">
                        {{data.buildingName}}
                    </div>
                </div>

                <!-- ___ Subject ___ -->
                <div class="row m-b-sm">
                    <div class="col-md-4">
                        <label>Subject</label>
                    </div>
                    <div class="col-md-8 fourteenPixelText">
                        {{data.subject}}
                    </div>
                </div>

                <!-- ___ Announcement  ___ -->
                <div class="row m-b-sm">
                    <div class="col-md-4">
                        <label>Announcement</label>
                    </div>
                    <div class="col-md-8 fourteenPixelText">
                        <pre>{{data.announcement}}</pre>
                    </div>
                </div>

                <!-- ___ Start Date ___ -->
                <div class="row m-b-sm long-date-field">
                    <div class="col-md-4">
                        <label>Start Date</label>
                    </div>
                    <div class="col-md-8 fourteenPixelText">
                        {{data.startDate | mccDate:true}}
                    </div>
                </div>

                <!-- ___ End Date ___ -->
                <div class="row m-b-md long-date-field">
                    <div class="col-md-4">
                        <label>End Date</label>
                    </div>
                    <div class="col-md-8 fourteenPixelText">
                        {{data.endDate | mccDate:true}}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/pass-on-log/view-pass-on-log-modal/view-pass-on-log-modal.component.html